import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getLevelScore, createScoreLabel } from './actions'
import { InfoPanel } from './infoPanel'
import { TOP_LEVEL } from './constants'
import './style.scss'

const PasswordMeterField = ({ handler, placeholder, disablePanel, disableLevel }) => {
  const [level, setLevel] = useState(0)
  const [visibility, setVisibility] = useState(false)
  const [info, setInfo] = useState(false)
  const label = createScoreLabel(level)
  const { t } = useTranslation()

  const handlerChange = (text) => {
    if (disableLevel) {
      handler(text)
      return
    }
    const level = getLevelScore(text)
    if (level === TOP_LEVEL) handler(text)
    else handler(null)
    setLevel(level)
  }

  return (
    <div className="password-meter-field">
      <div className="wrapper-input">
        <input
          type={visibility ? 'text' : 'password'}
          onChange={(e) => handlerChange(e.target.value)}
          placeholder={placeholder}
        />
        <div className="options">
          <span className={visibility ? 'fa fa-eye' : 'fa fa-eye-slash'} onClick={() => setVisibility(!visibility)} />

          {!disablePanel && (
            <span
              className="fa fa-info-circle"
              onMouseEnter={() => setInfo(true)}
              onMouseLeave={() => setInfo(false)}
            />
          )}
        </div>

        {info && <InfoPanel />}
      </div>

      {!disableLevel && (
        <div className="loading-meter">
          <div className={`fill-meter ${label}`}>
            <div className="fill-level">{t(label)}</div>
          </div>
        </div>
      )}
    </div>
  )
}

export default PasswordMeterField
